const VMOverview = () => import('@/components/VM/VMOverview.vue');

const VMDetails = () => import('@/components/VM/VMDetails.vue');
const VMDetailsWindows = () => import('@/components/VM/VMDetailsWindows.vue');

import VM from '@/views/VM/VM.vue';

export const vmRoutes = {
  path: 'vm',
  name: 'vm',
  component: VM,
  redirect: {
    name: 'overview',
  },
  children: [
    {
      // This opens up the child components
      name: 'overview',
      path: '',
      component: VMOverview,
    },
    {
      // This opens up the child components
      name: 'details',
      path: 'details',
      component: VMDetails,
    },
    {
      // This opens up the child components
      name: 'detailsWindows',
      path: 'details-windows',
      component: VMDetailsWindows,
    },
  ],
};
